import script from "./TextArea.vue?vue&type=script&setup=true&lang=ts"
export * from "./TextArea.vue?vue&type=script&setup=true&lang=ts"

import "./TextArea.vue?vue&type=style&index=0&id=1de320d0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1de320d0"]])

export default __exports__